<template>
  <div style="width: 100%">
    <v-card class="card-pad d-flex align-center mb-4" height="75" width="100%">
      <v-btn
        depressed
        small
        text
        color="grey"
        @click="back"
        style="position: absolute; left: 15px"
      >
        <v-icon x-small>mdi-arrow-left-bold</v-icon>
        {{ $t('Voltar') }}
      </v-btn>
      <v-spacer></v-spacer>
      <strong>Automação</strong>
      <v-spacer></v-spacer>
    </v-card>

    <v-card
      v-if="automation.id"
      class="card-container white--text py-4 my-4"
      width="100%"
      :color="automation.active ? 'success' : 'error'"
    >
      <span>Status: </span>
      <strong>{{ automation.active ? 'Ativo' : 'Inativo' }}</strong>
    </v-card>

    <v-card class="card-container mt-4" width="100%">
      <div>
        <strong>Dados da Automação</strong>
        <v-divider class="my-4"></v-divider>

        <v-row class="ma-0" dense>
          <v-col cols="12">
            <label class="label ml-1">Nome: </label>
            <strong> {{ automation.name }} </strong>
          </v-col>

          <v-col cols="12">
            <label class="label ml-1">Abertura baseada em: </label>
            <strong>
              {{
                openBasedOnOptions[automation.openBasedOn]
                  ? openBasedOnOptions[automation.openBasedOn].text
                  : 'Sem registro'
              }}
            </strong>
          </v-col>

          <v-col cols="12">
            <label class="label ml-1">Repetição: </label>
            <strong>
              {{
                repeatPeriodOptions[automation.repeatPeriod]
                  ? repeatPeriodOptions[automation.repeatPeriod].text
                  : 'Sem registro'
              }}
            </strong>
          </v-col>

          <v-col cols="12">
            <label class="label ml-1">Válido em fins de semana: </label>
            <strong>
              {{ automation.validOnWeekends ? 'Sim' : 'Não' }}
            </strong>
          </v-col>

          <v-col cols="12">
            <label class="label ml-1">Válido em feriados: </label>
            <strong>
              {{ automation.validOnHolidays ? 'Sim' : 'Não' }}
            </strong>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <v-card class="card-container mt-4" width="100%">
      <div>
        <strong>Modelo de Ordem de Serviço</strong>
        <v-divider class="my-4"></v-divider>

        <v-row class="ma-0" dense>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Instituição: </label>
            <strong>{{ institution.name }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Unidade: </label>
            <strong>{{
              automation.unidade ? automation.unidade.name : 'Sem registro'
            }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Categoria: </label>
            <strong>{{
              categories[automation.category]
                ? categories[automation.category].text
                : 'Sem registro'
            }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Nome O.S.: </label>
            <strong>{{ automation.nameOS }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Solicitante: </label>
            <strong>{{ automation.requester }}</strong>
          </v-col>
          <v-col cols="12" sm="6" v-if="institution.workshopType == 1">
            <label class="label ml-1">{{ $t('Oficina') }}: </label>
            <strong>{{
              automation.workshop ? automation.workshop.name : 'Sem registro'
            }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Tipo O.S.: </label>
            <strong>{{
              serviceOrderTypes[automation.serviceOrderType]
                ? serviceOrderTypes[automation.serviceOrderType].text
                : 'Sem registro'
            }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Responsável: </label>
            <strong>{{ automation.responsibleName }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Data de Solicitação: </label>
            <strong>{{ formatDate(automation.requestDate) }}</strong>
          </v-col>
          <v-col cols="12" sm="6">
            <label class="label ml-1">Externa: </label>
            <strong>{{ automation.isExternal ? 'Sim' : 'Não' }}</strong>
          </v-col>
          <v-col cols="12">
            <label class="label ml-1">Solicitação / Reclamação: </label>
            <br />
            <p class="ml-1">{{ automation.request }}</p>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <v-card class="card-container mt-4" width="100%">
      <div>
        <strong>Ordens de serviço</strong>
        <v-divider class="my-4"></v-divider>
      </div>

      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          class="primary-button ma-1"
          depressed
          @click="showFilters = !showFilters"
        >
          {{ showFilters ? 'Fechar filtros' : 'Filtros' }}
        </v-btn>
      </div>

      <v-expand-transition>
        <v-row v-if="showFilters" class="ma-0" dense>
          <v-col cols="12" sm="3">
            <label class="label ml-1">Número</label>
            <v-text-field
              :disabled="loading"
              v-model="filter.serviceOrderNumber"
              hide-details="auto"
              type="number"
              outlined
              class="primary-input"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label ml-1">Data de solicitação (De)</label>
            <v-menu
              ref="menuStartDate"
              v-model="menuStartDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details="auto"
                  v-model="startDate"
                  v-mask="['##/##/####']"
                  placeholder="Inicial"
                  prepend-inner-icon="mdi-calendar"
                  @blur="filter.requestStartDate = parseDate(startDate)"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input mr-1"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter.requestStartDate"
                min="1900-01-01"
                @change="saveRequestDate"
                no-title
                locale="pt"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label ml-1">Data de solicitação (Até)</label>
            <v-menu
              ref="menuEndDate"
              v-model="menuEndDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details="auto"
                  v-model="endDate"
                  placeholder="Final"
                  @blur="filter.requestEndDate = parseDate(endDate)"
                  v-mask="['##/##/####']"
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  autocomplete="off"
                  outlined
                  class="primary-input"
                ></v-text-field>
              </template>
              <v-date-picker
                class="ma-0"
                v-model="filter.requestEndDate"
                @change="saveRequestDate"
                locale="pt"
                no-title
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label ml-1">Arquivada</label>
            <v-select
              single-select
              append-icon="mdi-chevron-down"
              :disabled="loading"
              v-model="filter.isArchived"
              hide-details="auto"
              :items="boolOptions"
              item-text="text"
              item-value="value"
              outlined
              class="primary-input"
            ></v-select>
          </v-col>

          <v-col cols="12" class="d-flex">
            <v-spacer></v-spacer>

            <v-btn
              color="#20202066"
              depressed
              class="clear-button ma-1"
              @click="resetFilters"
            >
              {{ $t('Limpar') }}
              <v-icon class="ml-2">mdi-cached</v-icon>
            </v-btn>

            <v-btn
              class="secondary-button ma-1"
              depressed
              :loading="loading"
              @click="getOSs"
            >
              Filtrar
              <v-icon class="ml-2">mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-expand-transition>

      <v-data-table
        :headers="headers"
        :items="orders"
        :items-per-page="pageSize"
        class="main-table"
        hide-default-footer
        mobile-breakpoint="0"
      >
        <template #[`item.serviceOrderType`]="{ item }">
          <span>{{
            serviceOrderTypes[item.serviceOrderType]
              ? serviceOrderTypes[item.serviceOrderType].text
              : 'Sem registro'
          }}</span>
        </template>
        <template #[`item.closeServiceOrderDateTime`]="{ item }">
          <span>{{
            item.closeServiceOrderDateTime
              ? formatDate(item.closeServiceOrderDateTime)
              : 'Sem registro'
          }}</span>
        </template>
        <template #[`item.dateTimeRequest`]="{ item }">
          <span>{{ formatDate(item.dateTimeRequest) }}</span>
        </template>

        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-center">
            <v-btn
              class="ma-2"
              small
              color="#f5f5f5"
              dark
              :to="`/editServiceOrder/${item.id}`"
              depressed
            >
              <v-icon color="#bbcf20">mdi-arrow-top-right-thick</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>

      <div class="pagination mx-2">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="orders.length">
            <span> 1 - {{ orders.length }} de {{ pager.totalItems }} </span>
            <br />
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="pager.totalPages"
            :total-visible="5"
          ></v-pagination>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import moment from 'moment'

export default {
  name: 'DetailAutomation',

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    const id = this.$route.query.id
    if (id) {
      this.editing = true
      this.getAutomation(id)
    }
  },

  data() {
    return {
      menuEndDate: false,
      endDate: null,
      menuStartDate: false,
      startDate: null,
      showFilters: false,
      automation: {},
      apiService: new ApiService(),
      loading: false,
      institution: {},
      user: {},
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'N O.S.',
          align: 'center',
          value: 'number',
          sortable: false,
        },
        {
          text: 'Nome O.S.',
          align: 'center',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'serviceOrderType',
          sortable: false,
        },
        {
          text: 'Dt. Solic.',
          align: 'center',
          value: 'dateTimeRequest',
          sortable: false,
        },
        {
          text: 'Dt. Fecham.',
          align: 'center',
          value: 'closeServiceOrderDateTime',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      openBasedOnOptions: [
        {
          text: 'Data de solicitação',
          value: 0,
        },
        {
          text: 'Data de fechamento',
          value: 1,
        },
      ],
      repeatPeriodOptions: [
        {
          text: 'Diária',
          value: 0,
        },
        {
          text: 'Semanal',
          value: 1,
        },
        {
          text: 'Quinzenal',
          value: 2,
        },
        {
          text: 'Mensal',
          value: 3,
        },
      ],
      categories: [
        {
          text: 'Equipamento',
          value: 0,
        },
        {
          text: 'Setor',
          value: 1,
        },
      ],
      boolOptions: [
        {
          text: 'Sim',
          value: true,
        },
        {
          text: 'Não',
          value: false,
        },
      ],
      serviceOrderTypes: [
        {
          text: 'Treinamento',
          value: 0,
        },
        {
          text: 'Segurança Elétrica',
          value: 1,
        },
        {
          text: 'Manutenção preventiva',
          value: 2,
        },
        {
          text: 'Instalação',
          value: 3,
        },
        {
          text: 'Inspeção de Rotina',
          value: 4,
        },
        {
          text: 'Corretiva',
          value: 5,
        },
        {
          text: 'Calibração',
          value: 6,
        },
        {
          text: 'Validação / Qualificação',
          value: 7,
        },
        {
          text: 'Serviços Administrativos',
          value: 8,
        },
        {
          text: 'Empréstimo',
          value: 9,
        },
      ],
      orders: [],
      page: 1,
      pageSize: 10,
      sizes: [10, 30, 90, 180],
      pager: {},
      filter: {
        serviceOrderNumber: null,
        requestStartDate: null,
        requestEndDate: null,
        status: [],
        isArchived: false,
      },
    }
  },

  methods: {
    saveRequestDate(date) {
      this.startDate = this.formatInputDate(this.filter.requestStartDate)
      this.$refs.menuStartDate.save(date)
      this.requestMinDate = new Date(this.filter.requestStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.filter.requestEndDate)
      this.$refs.menuEndDate.save(date)
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    getOSs() {
      this.loading = true

      const model = {
        automationId: this.automation.id,
        page: this.page,
        pageSize: this.pageSize,
        ...this.filter,
      }

      this.apiService
        .post('orderAutomation/list-os', model)
        .then((response) => {
          this.orders = response.content.data
          this.pager = response.content.pager
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetFilters() {
      this.startDate = null
      this.endDate = null
      this.filter = {
        serviceOrderNumber: null,
        requestStartDate: null,
        requestEndDate: null,
        status: [],
        isArchived: false,
      }
      this.getOSs
    },

    back() {
      this.$router.go(-1)
    },

    getAutomation(id) {
      this.loading = true
      this.apiService
        .get('orderAutomation/' + id)
        .then((response) => {
          this.automation = { ...this.automation, ...response.content }
          this.getOSs()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy HH:mm') : date
    },
  },

  watch: {
    pageSize() {
      this.getOSs()
    },

    page() {
      this.getOSs()
    },
  },
}
</script>

<style></style>
